import React from 'react'
import classNames from 'classnames'
import './checkbox.sass'

class Checkbox extends React.Component {
    render() {
        return (
            <div className={classNames('checkbox', {checked: this.props.checked})}>
                <div className="checkbox__switcher">
                    <input
                        id={this.props.id}
                        name={this.props.name}
                        onChange={this.props.onChange}
                        type="checkbox"
                        checked={this.props.checked}
                    />
                    <div className="checkbox__trigger" onClick={this.props.onChange}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                            <rect x="0.5" y="0.5" width="31" height="31" fill="white" stroke="#A5A8B0"/>
                          {this.props.checked ? (
                            <path d="M23.622 10.4191C23.8534 10.0756 23.7626 9.60947 23.4191 9.37802C23.0756 9.14656 22.6095 9.2374 22.378 9.58091L23.622 10.4191ZM15.5882 21L15.0235 21.4935C15.1768 21.6689 15.4028 21.7631 15.6352 21.7485C15.8676 21.7339 16.0801 21.6122 16.2102 21.4191L15.5882 21ZM11.5647 15.2565C11.2922 14.9446 10.8183 14.9127 10.5065 15.1853C10.1946 15.4578 10.1627 15.9317 10.4353 16.2435L11.5647 15.2565ZM22.378 9.58091L14.9663 20.5809L16.2102 21.4191L23.622 10.4191L22.378 9.58091ZM16.153 20.5065L11.5647 15.2565L10.4353 16.2435L15.0235 21.4935L16.153 20.5065Z" fill="#646771"/>
                          ) : null}
                          </svg>
                    </div>
                </div>
            </div>
        )
    }
}

export default Checkbox
